"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyNav = exports.useMonthlyCalendar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = __importStar(require("react"));
const MonthlyCalendarContext = react_1.default.createContext(null);
const useMonthlyCalendar = () => (0, react_1.useContext)(MonthlyCalendarContext);
exports.useMonthlyCalendar = useMonthlyCalendar;
exports.default = ({ locale, currentMonth, onCurrentMonthChange, children, date, min, max, }) => {
    let monthStart = (0, date_fns_1.startOfMonth)(currentMonth);
    let days = (0, date_fns_1.eachDayOfInterval)({
        start: monthStart,
        end: (0, date_fns_1.endOfMonth)(monthStart),
    });
    return ((0, jsx_runtime_1.jsx)(MonthlyCalendarContext.Provider, { value: {
            min,
            max,
            date,
            days,
            locale,
            onCurrentMonthChange,
            currentMonth: monthStart,
        }, children: children }));
};
const MonthlyNav = ({ children }) => {
    const calendar = (0, exports.useMonthlyCalendar)();
    // return (
    //   <div className="flex justify-end mb-4">
    //     <button
    //       onClick={() => onCurrentMonthChange(subMonths(currentMonth, 1))}
    //       className="cursor-pointer"
    //     >
    //       Previous
    //     </button>
    //     <div className="ml-4 mr-4 w-32 text-center" aria-label="Current Month">
    //       {format(
    //         currentMonth,
    //         getYear(currentMonth) === getYear(new Date()) ? "LLLL" : "LLLL yyyy",
    //         { locale }
    //       )}
    //     </div>
    //     <button
    //       onClick={() => onCurrentMonthChange(addMonths(currentMonth, 1))}
    //       className="cursor-pointer"
    //     >
    //       Next
    //     </button>
    //   </div>
    // );
    return children(calendar?.locale, calendar?.currentMonth, calendar?.onCurrentMonthChange);
};
exports.MonthlyNav = MonthlyNav;
